import Id from './Id';
import Name from './Name';
import NtaxCode from './NtaxCode';
import SupplierNtaxCode from './SupplierNtaxCode';
import TaxNumber from './TaxNumber';
import Type from './Type';
import CustomName from './CustomName';
import JobNumber from './JobNumber';
import CostCentre from './CostCentre';
import WebNtaxCode from './WebNtaxCode';

export const labels = {
  Id: 'Azonosító',
  Name: 'Név',
  CustomName: 'Egyedi NTAX név',
  JobNumber: 'Munkaszám',
  CostCentre: 'Költséghely',
  WebNtaxCode: 'Web NTAX kód',
  NtaxCode: 'Vevő NTAX kód',
  SupplierNtaxCode: 'NTAX kód',
  TaxNumber: 'Adószám',
  Type: 'Típus',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Type',
}, {
  value: 'CustomName',
}, {
  value: 'SupplierNtaxCode',
}, {
  value: 'JobNumber',
}, {
  value: 'CostCentre',
}, {
  value: 'WebNtaxCode',
}, {
  value: 'TaxNumber',
}, {
  value: 'NtaxCode',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'CustomName',
}, {
  value: 'Type',
}, {
  value: 'NtaxCode',
}, {
  value: 'SupplierNtaxCode',
}, {
  value: 'WebNtaxCode',
}, {
  value: 'JobNumber',
}, {
  value: 'CostCentre',
}, {
  value: 'TaxNumber',
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Id,
  Name,
  Type,
  NtaxCode,
  SupplierNtaxCode,
  TaxNumber,
  CustomName,
  JobNumber,
  CostCentre,
  WebNtaxCode,
};
